import { useDictionary } from "../../../../../../utilities/hooks/UseDictionary";
import pencil from '../../../../../../assets/icons/ic_pencil.svg';
import PropTypes from 'prop-types'
import useClientWidth from "../../../../../../utilities/hooks/useClientWidth";
import moment from "moment";
import {URI_GOOGLE_MAPS_PLACE_ID} from "../../../../../../config";

const PointOfInterestDetails = ({details}) => {
    const dictionary = useDictionary();
    const clientWidth = useClientWidth();

    const displayDate = (date,isTime) => {
        if (!date) return '';
        const formattedDate = moment(date * 1000).format('MMM DD, YYYY');
        if (isTime) {
            const formattedTime = moment(date * 1000).format('HH:mm');
            return `${formattedDate} ${formattedTime}`;
        }
        return formattedDate;
    }

    return (
        <div
			className="booking-experience-details-container provider-customer-details"
		>
            <div
				className="settings-tab-bar"
				style={{
					justifyContent: 'space-between',
					backgroundColor: 'white',
					alignItems: 'center',
					borderTopLeftRadius: 12,
					borderTopRightRadius: 12
				}}
			>
				<div
					className="settings-tab"
					style={{ color: 'var(--brand-dark-blue)', cursor: 'initial' }}
				>
					{dictionary.details}
				</div>
			</div>
            <div className="booking-experience-details-content-container thin-scrollbar">
                <div className="participant-row-container" style={{ justifyContent: 'space-between' }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_Input}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details?.input}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_Search_Input}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details?.search_input}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_Place_Id}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details?.place_id ? <a target="_blank" href={URI_GOOGLE_MAPS_PLACE_ID + details.place_id}>{details.place_id}</a> : ''}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_Name}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details?.name}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_PBM}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details?.poi_booking_module_eligibility}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_OBM}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details?.operator_booking_module_eligibility}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_Location_Type}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details?.location_type}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_Matched}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details?.matched}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_Status}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details?.status}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_Iteration}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details.iteration ? displayDate(details.iteration,true) : '-'}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_Parsed_At}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details.parsed_at ? displayDate(details.parsed_at,true) : '-'}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_Force_Update}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details?.force_update}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.providerCreateDate}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details.created_at ? displayDate(details.created_at,true) : '-'}
                    </h4>
                </div>
                <div className="participant-row-container" style={{ justifyContent: 'space-between', marginTop: (clientWidth >= 767 ? '24px' : '16px') }}>
                    <h4 style={{ opacity: 0.6, fontWeight: 'normal' }}>
                        {dictionary.Poi_Place_Status}
                    </h4>
                    <h4 style={{ fontWeight: 'normal' }}>
                        {details?.closed}
                    </h4>
                </div>
            </div>
        </div>
    )
}

PointOfInterestDetails.propTypes = {
    details: PropTypes.object
}
export default PointOfInterestDetails;